<template>
  <div class="firstclassifi" v-loading="loading">
    <div class="firstclassifi-div">
      <div class="firstclassifi-div-first">
        <div class="firstclassifi-div-first-addition" @click="additionClick">
          <img
            class="first-addition-img"
            src="../../assets/common/common-add.png"
          />
          <div class="first-addition-title">添加</div>
        </div>
      </div>
      <div class="firstclassifi-div-second">
        <el-table
          :data="tableData"
          border
          style="width: 100%; cursor: pointer"
          :header-cell-style="{
            color: '#333333',
            backgroundColor: '#FAFAFA',
          }"
        >
          <!-- 自定义暂无数据 -->
          <template slot="empty">
            <div class="empty-block">
              <img
                class="empty-block-img"
                src="../../assets/common/common-empty.png"
              />
              <div class="empty-block-text">暂无数据～</div>
            </div>
          </template>

          <el-table-column
            prop="jin_name"
            label="金刚区名称"
            width="140"
          ></el-table-column>
          <el-table-column prop="name" label="商品名称"></el-table-column>
          <el-table-column label="商品图片" width="98">
            <template slot-scope="scope">
              <div class="table-cover">
                <img class="table-cover-img" :src="scope.row.image" alt="" />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="售价(元)">
            <template slot-scope="scope">
              <span>¥</span> {{ scope.row.price }}
            </template>
          </el-table-column>

          <el-table-column prop="sort" label="排序">
            <template slot-scope="scope">
              <div class="table-sort" @click="sortBtn(scope.row)">
                <!-- <img
                  class="table-sort-left"
                  :src="
                    scope.row.jinIndex == 1
                      ? require('../../assets/marketing/marketing-top.png')
                      : require('../../assets/marketing/marketing-no.png')
                  "
                  alt=""
                /> -->
                <img
                  class="table-sort-left"
                  src="../../assets/marketing/marketing-no.png"
                  alt=""
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="operation" label="操作">
            <template slot-scope="scope">
              <div class="operation">
                <div class="compile" @click="compileBtn(scope.row)">编辑</div>

                <div class="delete" @click="deteleBtn(scope.row)">删除</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="firstclassifi-div-Pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="prev, pager, next, sizes"
          :total="totalNum"
        >
        </el-pagination>
      </div>
    </div>

    <!--一级分类  添加弹出框-->
    <div class="addition">
      <el-dialog
        :visible.sync="additionDialogVisible"
        width="444px"
        style="margin-top: 15vh"
        :show-close="false"
        @close="additionReset"
      >
        <span slot="footer" class="dialog-footer">
          <div class="addition-div">
            <div class="addition-div-top">
              <div class="div-top-title">
                {{ compileShow == false ? '商品添加' : '商品编辑' }}
              </div>
              <img
                class="div-top-close"
                src="../../assets/common/close.png"
                @click="additionReset"
              />
            </div>

            <div class="addition-div-center">
              <div class="center-title">商品名称</div>
              <div class="center-input">
                <el-autocomplete
                  class="inline-input"
                  v-model="suggestValue"
                  :fetch-suggestions="querySearch"
                  placeholder="请输入内容"
                  :trigger-on-focus="false"
                  @select="handleSelect"
                  clearable
                ></el-autocomplete>
              </div>
              <div class="center-title">商品id</div>
              <div class="center-select">
                <el-input
                  placeholder="请输入内容"
                  v-model="additionTypeId"
                  clearable
                  :disabled="true"
                >
                </el-input>
              </div>
            </div>

            <div class="addition-div-button">
              <!-- <div class="addition-div-button-reset" @click="additionReset">
                重置
              </div> -->
              <div class="addition-div-button-confirm" @click="additionConfirm">
                确定
              </div>
            </div>
          </div>
        </span></el-dialog
      >
    </div>

    <!-- 第二区域  删除 -->
    <div class="detele">
      <el-dialog
        :visible.sync="deteleDialogVisible"
        width="394px"
        style="margin-top: 10vh"
        @close="cancelDetele"
      >
        <span slot="footer" class="dialog-footer">
          <div class="detele-div">
            <img
              class="detele-div-img"
              src="../../assets/common/common-warning.png"
            />
            <div class="detele-div-title">是否确定删除该商品？</div>
            <div class="detele-div-text"></div>
            <div class="detele-div-button">
              <div class="detele-div-button-left" @click="confirmDetele">
                确定
              </div>
              <div class="detele-div-button-right" @click="cancelDetele">
                取消
              </div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getMarketKingsecon,
  postMarketKingseconAdd,
  putfnMarketKingsecon,
  deletefnMarketKingsecon,
} from '../../api/marketing'

import Bus from '../../utils/bus' // bus发送跳转关闭临时组件

import { getMarketList } from '../../api/commodity'

export default {
  data() {
    return {
      // 第二模块 表格数组数据
      tableData: [],
      // 第二区域表格条数
      totalNum: 0,
      // 添加弹出框区域
      additionDialogVisible: false,
      // 添加弹出框  带建议搜索框数组
      restaurants: [],
      // 添加弹出框  带建议搜索框数组
      suggestValue: '',
      // 添加弹出框 选中
      additionTypeId: '',
      // end

      // 商品区域 编辑区域  判断用户是从编辑点击区域进入
      compileShow: false,
      /* 删除弹出框 */
      deteleDialogVisible: false,
      // 页码
      page: 1,
      // 页数
      limit: 10,
      // 监听用户刷新
      loading: false,
      // 获取上级传递参数
      firstId: '',
      firstName: '',
      firstJinId: '',
    }
  },
  created() {
    // 获取上级传递参数
    this.firstJinId = this.$route.query.id
    this.loading = true
    this.getMarketKingClick()
  },
  // 控制页面刷新或者挂载完后进行权限开启
  updated() {
    if (this.firstJinId == undefined) {
      Bus.$emit('detele', 'marketingFirstclassifi')
    }
  },
  methods: {
    // 获取对应
    getMarketKingClick() {
      let params = {
        id: '',
        name: '',
        jin_id: this.firstJinId,
        pageSize: this.limit,
        pageNo: this.page,
      }

      getMarketKingsecon(params).then((res) => {
        if (res.resultStatus == true) {
          // 表格数组
          this.tableData = res.resultData.goodsList
          // 表格数组条数
          this.totalNum = res.resultData.totalNum
          this.loading = false
        }
      })
    },
    // 用户点击添加按钮开启弹出框
    additionClick() {
      this.additionTypeId = ''
      this.suggestValue = ''

      this.compileShow = false
      this.additionDialogVisible = true
    },

    // 模糊搜索\
    querySearch(queryString, cb) {
      if (queryString == '') {
        cb(this.restaurant)
      } else {
        let params = {
          id: '', // 商品id
          name: this.suggestValue, // 商品名称
          code: '', // 商品编号
          chandi: '', // 产地
          is_speciality: '', // 是否为特产  1是
          is_handpick: '', // 是否精选 1是
          goods_one_type_id: '', // 一级分类id
          goods_two_type_id: '', // 二级分类id
          supplier_name: '', // 供应商名称
          brand_name: '', // 品牌名称
          status: 1, // 状态:1=上架,2=下架 30活动中
          pageSize: 99999999, // 页码
          pageNo: 1, // 页数
        }

        getMarketList(params, { condition: queryString }).then((res) => {
          if (res.resultStatus == true) {
            this.restaurant = res.resultData.goodsList
            //这个插件只能过滤key为value得值.所以要把获取到得后台字段给重新赋值为value
            res.resultData.goodsList.map((item) => {
              item.value = item.name
              return item
            })

            cb(res.resultData.goodsList)
          }
        })
      }
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        )
      }
    },
    loadAll() {
      return this.restaurant
    },
    handleSelect(item) {
      console.log('选中对应的对象', item)
      // 添加
      this.additionTypeId = item.id
    },

    // 商品区域 排序
    sortBtn(item) {
      console.log(item)
      let params = item.id
      putfnMarketKingsecon(params).then((res) => {
        console.log('获取对应的额params', res)
        if (res.resultStatus == true) {
          this.loading = true
          this.$message({
            message: '置顶成功',
            type: 'success',
          })
          this.getMarketKingClick()
        }
      })
    },
    // 添加弹出框 确定
    additionConfirm() {
      let params = {
        id: this.additionTypeId, // 商品id
        jin_id: this.firstJinId, // 金刚区id
      }

      postMarketKingseconAdd(params).then((res) => {
        if (res.resultStatus == true) {
          this.loading = true
          this.$message({
            message: '添加成功！',
            type: 'success',
          })
          this.additionDialogVisible = false
          this.getMarketKingClick()
        }
      })
    },
    // 添加弹出框 重置
    additionReset() {
      this.additionDialogVisible = false
    },

    /*end */
    // 商品列表区域
    compileBtn(item) {
      this.compileShow = true
      this.suggestValue = item.name
      this.additionTypeId = item.id

      this.$nextTick(() => {
        this.additionDialogVisible = true
      })
    },
    /* 删除 */
    // 开启删除弹出框
    deteleBtn(item) {
      this.additionTypeId = item.id
      this.deteleDialogVisible = true
    },
    // 确定删除框
    confirmDetele() {
      let params = this.additionTypeId

      deletefnMarketKingsecon(params).then((res) => {
        if (res.resultStatus == true) {
          this.loading = true
          this.$message({
            message: '删除成功！',
            type: 'success',
          })
          this.deteleDialogVisible = false
          this.getMarketKingClick()
        }
      })
    },

    // 取消删除弹出框
    cancelDetele() {
      this.additionTypeId = ''
      this.deteleDialogVisible = false
    },

    // 查询当前页码多少条
    handleSizeChange(val) {
      this.limit = val
      this.loading = true
      console.log(`每页 ${val} 条`)
      this.getMarketKingClick()
    },
    // 查询当前页
    handleCurrentChange(val) {
      this.page = val
      this.loading = true
      console.log(`当前页: ${val}`)
      this.getMarketKingClick()
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-input__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-textarea__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: rgba(255, 255, 255, 0);
}

.firstclassifi {
  background: #ffffff;
  height: 100%;
  .firstclassifi-div {
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    padding: 0 24px;
    box-sizing: border-box;
    .firstclassifi-div-first {
      height: 80px;
      display: flex;
      align-items: center;

      .firstclassifi-div-first-addition {
        width: 82px;
        height: 36px;
        background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .first-addition-img {
          width: 13px;
          height: 13px;
        }

        .first-addition-title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          margin-left: 8px;
        }
      }
    }

    .firstclassifi-div-second {
      /deep/ .el-table .el-table__cell {
        padding: 13px 0;
        vertical-align: top;
      }
      /deep/ .el-table thead {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        background: #d8d8d8;
      }

      /deep/ .el-table tr {
        height: 46px;
      }

      /deep/ .el-table__empty-text {
        line-height: 0;
      }

      .empty-block {
        margin-top: 62px;
        padding-bottom: 40px;
        .empty-block-img {
          width: 130px;
          height: 130px;
          margin: 0 auto;
        }

        .empty-block-text {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          margin-top: 10px;
          height: 17px;
          line-height: 17px;
        }
      }
      .table-cover {
        width: 70;
        height: 70px;
        .table-cover-img {
          width: 70;
          height: 70px;
          background: #e9edf4;
          border-radius: 5px;
        }
      }

      .table-status {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #555555;
      }

      .table-set {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2aa4ff;
        text-decoration: underline;
      }

      .table-sort {
        display: flex;

        .table-sort-left,
        .table-sort-right {
          width: 26px;
          height: 26px;
        }

        .table-sort-right {
          margin-left: 4px;
        }
      }

      .operation {
        display: flex;

        .compile,
        .delete {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2aa4ff;
          text-decoration: underline;
        }

        .delete {
          margin-left: 24px;
        }
      }
    }

    .firstclassifi-div-Pagination {
      height: 88px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      /deep/ .el-pagination .btn-prev {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        margin-right: 8px;
      }

      /deep/ .el-pagination .btn-next {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
      }

      /deep/ .el-pager li {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        line-height: 32px;
        margin-right: 8px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }

      /deep/ .el-pager li.active {
        background: #000000;
        color: #ffffff;
      }

      /deep/ .el-input--mini .el-input__inner {
        height: 32px;
      }

      /deep/ .el-input__inner {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }

  .addition {
    /deep/ .el-dialog {
      height: 280px;
    }
    /deep/ .el-dialog__footer {
      padding: 0;
      text-align: left;
    }
    .addition-div {
      .addition-div-top {
        display: flex;
        height: 56px;
        align-items: center;
        justify-content: space-between;
        padding: 0 24px;
        box-sizing: border-box;
        border-bottom: 1px solid #e9edf4;

        .div-top-title {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #222222;
        }

        .div-top-close {
          width: 10px;
          height: 10px;
          cursor: pointer;
        }
      }

      .addition-div-center {
        padding: 0 24px;
        box-sizing: border-box;
        margin-top: 20px;
        width: 100%;
        .center-title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .center-input {
          width: 100%;
          height: 32px;
          margin-top: 4px;
          margin-bottom: 16px;
          /deep/ .el-autocomplete {
            width: 100%;
          }

          /deep/ .el-input {
            width: 100%;
            height: 32px;
          }

          /deep/ .el-input__inner {
            padding: 0 10px;
            box-sizing: border-box;
            height: 32px;
            background-color: rgba(255, 255, 255, 0);
          }
        }

        .center-select {
          margin-top: 4px;
          width: 100%;
          height: 32px;
          /deep/ .el-select {
            width: 100%;
          }

          /deep/ .el-input--suffix .el-input__inner {
            height: 32px;
          }

          /deep/ .el-select .el-input.is-focus .el-input__inner {
            border-color: rgba(217, 217, 217, 1);
          }
        }
      }

      .addition-div-button {
        display: flex;
        height: 52px;
        align-items: center;
        justify-content: flex-end;
        padding: 0 24px;
        box-sizing: border-box;
        margin-top: 22px;
        border-top: 1px solid #e9edf4;

        .addition-div-button-reset,
        .addition-div-button-confirm {
          width: 65px;
          height: 32px;
          background: #ffffff;
          border-radius: 10px;
          border: 1px solid #e9edf4;
          text-align: center;
          line-height: 32px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
          cursor: pointer;
        }

        .addition-div-button-confirm {
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          color: #ffffff;
          margin-left: 8px;
        }
      }
    }
  }

  /* 右侧删除弹出框 */
  .detele {
    /deep/ .el-dialog {
      height: 231px;
    }

    /deep/ .el-dialog__footer {
      padding: 0;
      box-sizing: border-box;
    }

    .detele-div {
      width: 100%;
      text-align: center;
      padding-top: 25px;
      .detele-div-img {
        width: 56px;
        height: 56px;
        margin: 0 auto;
      }

      .detele-div-title {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        margin-top: 20px;
      }

      .detele-div-text {
        width: 319px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 20px;
        margin: 0 auto;
        margin-top: 2px;
      }

      .detele-div-button {
        display: flex;
        justify-content: center;
        align-content: center;
        margin-top: 18px;

        .detele-div-button-left,
        .detele-div-button-right {
          width: 88px;
          height: 32px;
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          border-radius: 10px;
          text-align: center;
          line-height: 32px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          cursor: pointer;
        }

        .detele-div-button-right {
          margin-left: 28px;
          border: 1px solid #e9edf4;
          color: rgba(0, 0, 0, 0.65);
          background: #ffffff;
        }
      }
    }
  }
}
</style>
